<script>
  import { afterUpdate } from "svelte"

  export let operation
  let canvas
  let ctx = ""

  const renderShape = (operation) => {
    return new Promise(async (resolve) => {
      ctx = canvas.getContext("2d")
      canvas.width = 150
      canvas.height = 150

      ctx.fillStyle = "#FFFFFF" // Your background color
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // ctx.beginPath()
      // ctx.moveTo(canvas.width / 2, 0)
      // ctx.lineTo(canvas.width / 2, canvas.height)

      // ctx.moveTo(0, canvas.height / 2)
      // ctx.lineTo(canvas.width, canvas.height / 2)
      // ctx.stroke()

      operation.data.forEach((pathData) => {
        const path = new Path2D(pathData.d)
        ctx.save()

        const SCALE = 0.18
        const ACTUAL_SIZE = 400

        let xPosition = canvas.width / 2 - (SCALE * ACTUAL_SIZE) / 2
        let yPosition = canvas.height / 2 - (SCALE * ACTUAL_SIZE) / 2

        ctx.setTransform(SCALE, 0, 0, SCALE, xPosition, yPosition)
        // ctx.setTransform(0.25, 0, 0, 0.25, canvas.width / 2 - (0.25 * operation.width) / 2, canvas.height / 2 - (0.25 * operation.height) / 2)
        // ctx.setTransform(0.25, 0, 0, 0.25, canvas.width / 2 - 0.25 * 200, canvas.height / 2 - 0.25 * 200)
        ctx.fillStyle = pathData.fill
        ctx.fill(path)
        ctx.restore()
      })
      resolve()
    })
  }

  //   $: changeColor(operation)
  afterUpdate(() => {
    changeColor(operation)
  })

  const changeColor = async (operation) => {
    if (canvas) {
      await renderShape(operation)
    }
  }
</script>

<div class="flex flex-col gap-3">
  <canvas bind:this={canvas} />
</div>
